.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chatRoot {
  flex: 1;
  display: flex;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  gap: 20px;
}

.chatContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: radial-gradient(
    108.78% 108.78% at 50.02% 19.78%,
    #ffffff 57.29%,
    #eef6fe 100%
  );
  box-shadow:
    0px 2px 4px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow-y: auto;
  max-height: calc(100vh - 105px);
}

.chatMessageStream {
  flex-grow: 1;
  max-width: 1028px;
  width: 100%;
  overflow-y: auto;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}

.chatMessageUser {
  align-items: flex-end;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  flex-direction: column;
}

.chatMessageUserFlex {
  display: flex;
}

.chatMessageUserMessage {
  padding: 20px;
  background: #edf5fd;
  border-radius: 8px;
  box-shadow:
    0px 2px 4px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #242424;
  flex: none;
  order: 0;
  flex-grow: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 800px;
}

.editIcon {
  align-items: center;
  background: #edf5fd;
  border-radius: 8px;
  box-shadow:
    0px 2px 4px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  color: #242424;
  display: flex;
  margin: 10px 16px;
  max-height: 42px;
  padding: 10px;
}

.editIcon:hover {
  cursor: pointer;
}

.editGlyph {
  width: 16px;
  height: 16px;
  color: inherit;
}

.chatMessageGpt {
  margin-bottom: 12px;
  max-width: 80%;
  display: flex;
  flex-direction: column;
}

.chatMessageIntent {
  opacity: 0.85;
  background-color: rgba(248, 248, 248, 0.9);
  border-left: 3px solid #254aa5;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  animation: fadeInSlide 0.3s ease-in-out;
}

.chatMessageDate {
  font-size: 11px;
  color: #666;
  font-style: italic;
  margin-top: 4px;
  text-align: left;
  opacity: 0.8;
}

.chatInput {
  position: sticky;
  flex: 0 0 100px;
  padding-top: 12px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  width: calc(100% - 100px);
  max-width: 1028px;
  margin-bottom: 50px;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
}

/* Circle + icon sizing matches Card.tsx (.circle 3rem, .icon 1.5rem). */
.clearChatBroom {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  color: #ffffff;
  border: 1px solid #d1d1d1;
  border-radius: 50%;
  z-index: 1;
  line-height: 0;
}

.clearChatBroomIcon {
  width: 1.5rem;
  height: 1.5rem;
  color: #ffffff;
  display: block;
  flex-shrink: 0;
}

.stopGeneratingContainer {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 16px;
  gap: 4px;
  position: absolute;
  width: 161px;
  height: 32px;
  left: calc(50% - 161px / 2 + 25.8px);
  bottom: 156px;
  border: 1px solid #d1d1d1;
  border-radius: 16px;
}

.stopGeneratingIcon {
  width: 14px;
  height: 14px;
  color: #424242;
}

.stopGeneratingText {
  width: 103px;
  height: 20px;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #242424;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.citationPanel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 16px;
  gap: 8px;
  background: #ffffff;
  box-shadow:
    0px 2px 4px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  flex: auto;
  order: 0;
  align-self: stretch;
  flex-grow: 0.3;
  max-width: 30%;
  overflow-y: auto;
  max-height: calc(100vh - 105px);
}

.citationPanelHeaderContainer {
  width: 100%;
}

.citationPanelHeader {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.citationPanelDismiss {
  width: 18px;
  height: 18px;
  color: #424242;
}

.citationPanelDismiss:hover {
  background-color: #d1d1d1;
  cursor: pointer;
}

.citationPanelTitle {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #323130;
  margin-top: 12px;
  margin-bottom: 12px;
}

.citationPanelContent {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.citationPanelDisclaimer {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  display: flex;
  color: #707070;
}

.citationPanelContent h1 {
  line-height: 30px;
}

.fetchMessagesSpinner {
  margin-top: 30vh;
}

.MobileChatContainer {
  @media screen and (max-width: 600px) {
    max-width: 100%;
    margin: 0 auto;
    padding: 8px;
  }
}

.mobileStyles {
  @media screen and (max-width: 600px) {
    max-width: 100%;
    flex-grow: 1;
    max-height: 100vh;
  }
}

.mobileclearChatBroom {
  @media screen and (max-width: 600px) {
    margin-left: -30px;
  }
}

.mobileCitationPanelTitle {
  @media screen and (max-width: 600px) {
    font-weight: 400;
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
}

.mobileCitationPanelContent {
  @media screen and (max-width: 600px) {
    font-weight: 250;
    font-size: 11px;
  }
}

.mobileCitationPanelDisclaimer {
  @media screen and (max-width: 600px) {
    font-weight: 250;
    font-size: 10px;
  }
}

.dataText {
  background: linear-gradient(90deg, #464feb 10.42%, #8330e9 100%);
  color: transparent;
  background-clip: text;
}

@media screen and (max-width: 600px) {
  h1 {
    font-weight: 300;
    font-size: 14px;
  }

  h2 {
    font-weight: 300;
    font-size: 12px;
  }
}

@keyframes fadeInSlide {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 0.85;
    transform: translateY(0);
  }
}

/* High contrast mode specific styles */
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .chatContainer,
  .chatMessageUserMessage {
    border: 2px solid WindowText;
    padding: 10px;
    background-color: Window;
    color: WindowText;
  }

  .citationPanel,
  .citationPanelHeader,
  .citationPanelTitle,
  .citationPanelContent {
    border: 2px solid WindowText;
    padding: 10px;
    background-color: Window;
    color: WindowText;
  }

  .chatMessageIntent {
    border: 2px solid WindowText;
    background-color: Window;
    color: WindowText;
  }
}

.exportButton:global(.ms-Button) :global(.ms-Button-label) {
  color: #115ea3;
  text-decoration: underline;
}
